/**
 * PortalKisayollari.jsx — firma portalı ana sayfasının üstündeki kimlik kartı (backlog #319 / #320 / #321,
 * 2026-10-11): aktif arayüz seti (ör. "Yerli Dekoratör") ve firmanın o fuardaki diğer setleri.
 *
 * #432 (2026-10-16, Bilge): kartın üstündeki KISAYOL DÜĞMELERİ (Organizatör Paneli, Taşeron ve Alt Firmalar, Firma Evrakları,
 * Personel, Standlar, Talepler, Projeler, Gerekli Belgeler) gereksiz bulunduğu için kaldırıldı; hepsinin kenar çubuğunda girişi
 * var (LayoutMenuData) ve "Firma Evrakları" artık Yüklemeler widget'ının dördüncü satırı (FirmaAnasayfaListPage). Kart, kısayol
 * olmayan parçalarıyla kalır: firma adı, aktif set rozeti, "başlıktan geçebilirsiniz" ipucu, Yabancı bilgi kutusu ve "portal yok"
 * uyarısı. Dosyanın ve bileşenin adı değişmedi (tek kullanıcısı FirmaAnasayfaListPage). Eski düğme listesi aşağıda yorum
 * satırı olarak duruyor.
 * Yabancı setlerde İSG yükü olmadığı ve personelin kimlik / pasaportla kart aldığı yazar.
 */
import React from "react";
import { Alert, Badge, Card, CardBody } from "reactstrap";
import { Globe } from "lucide-react";
import { usePortal } from "../Contexts/PortalContext";
// WAS (until #704): import { yabanciKatilimciMi } from "../Kisi/YabanciKatilimciParcalari";
import { sadePanelMi } from "../../services/sadePanel";
import { useTranslation } from "react-i18next";

// WAS (until #432):
// import { Link } from "react-router-dom";
// import { Users, FileText, Store, ClipboardList, FolderKanban, Repeat, Megaphone, ListChecks, Globe } from "lucide-react";
// import { enAz, MODUL, SEVIYE } from "../../services/portalService";
// import i18n from "../../i18n";
//
// const KISAYOLLAR = [
//   { modul: MODUL.FIRMA_YONETIMI, yol: "/Firma/Organizator", get ad() { return i18n.t("components:portalKisayollari.organizatorPaneli"); }, ikon: Megaphone },
//   { modul: MODUL.TASERON, yol: "/Firma/Taseronlar", get ad() { return i18n.t("components:portalKisayollari.taseronVeAltFirmalar"); }, ikon: Repeat, min: SEVIYE.WRITE },
//   { modul: MODUL.FIRMA_BELGELERI, yol: "/Firma/FirmaKart", get ad() { return i18n.t("components:portalKisayollari.firmaEvraklari"); }, ikon: FileText },
//   { modul: MODUL.PERSONEL, yol: "/Firma/Personel", get ad() { return i18n.t("components:portalKisayollari.personel"); }, ikon: Users },
//   { modul: MODUL.STANDLAR, yol: "/Firma/Standlar", get ad() { return i18n.t("components:portalKisayollari.standlar"); }, ikon: Store },
//   { modul: MODUL.TALEPLER, yol: "/Firma/Talepler", get ad() { return i18n.t("components:portalKisayollari.talepler"); }, ikon: ClipboardList },
//   { modul: MODUL.PROJELER, yol: "/Firma/Projeler", get ad() { return i18n.t("components:portalKisayollari.projeler"); }, ikon: FolderKanban, rol: "DEKORATOR" },
//   { modul: MODUL.BELGE_GEREKSINIMLERI, yol: "/Firma/BelgeGereksinimleri", get ad() { return i18n.t("components:portalKisayollari.gerekliBelgeler"); }, ikon: ListChecks },
// ];

export default function PortalKisayollari() {
  const { t } = useTranslation("components");
  const portal = usePortal();
  if (!portal?.aktif) {
    return portal?.uyari ? <Alert color="warning" className="small">{portal.uyari}</Alert> : null;
  }
  // #535 (2026-10-21, Deniz): the Yabancı Katılımcı sees no identity card at all (company name, set chip, the "foreign company: OHS staff and
  // OHS documents are not required" note): the top bar already names the set and the pages say what is asked. WAS: drawn for every set.
  // #704: the same for every company login while Sade panel modu is ON. WAS (until #704): if (yabanciKatilimciMi(portal)) return null;
  if (sadePanelMi(portal)) return null;
  const { aktif } = portal;
  // WAS (until #432): const gorunen = KISAYOLLAR.filter((k) => enAz(portal.seviye(k.modul), k.min ?? SEVIYE.READ)
  //   && (!k.rol || k.rol === aktif.rol));

  return (
    <Card className="mb-3 border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="text-muted small">{portal.firma?.firmaName}</span>
          <Badge color="primary" pill>{aktif.ad}</Badge>
          {portal.arayuzler.length > 1 && (
            <span className="text-muted small">
              {t("portalKisayollari.buFuarda")}{" "}{portal.arayuzler.map((a) => a.ad).join(" · ")}{" "}{t("portalKisayollari.basliktanGecebilirsiniz")}
            </span>
          )}
        </div>
        {aktif.yabanci && (
          <Alert color="info" className="small py-2 mt-2 mb-0 d-flex align-items-center gap-2">
            <Globe size={14} />
            {t("portalKisayollari.yabanciFirmaIsgPersoneliVe")}
          </Alert>
        )}
        {/* WAS (until #432): the shortcut buttons
        <div className="d-flex flex-wrap gap-2">
          {gorunen.map((k) => {
            const Ikon = k.ikon;
            const salt = !enAz(portal.seviye(k.modul), SEVIYE.WRITE);
            return (
              <Link key={k.yol} to={k.yol} className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1">
                <Ikon size={14} /> {k.ad}
                {salt && k.modul !== MODUL.BELGE_GEREKSINIMLERI && (
                  // #418: hover says why (the set, the role or a SAKA restriction)
                  <Badge color="light" className="text-muted ms-1" title={portal.ipucu ? portal.ipucu(k.modul, SEVIYE.WRITE) || undefined : undefined}>
                    {t("portalKisayollari.saltOkunur")}
                  </Badge>
                )}
              </Link>
            );
          })}
        </div>
        */}
      </CardBody>
    </Card>
  );
}
